import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";
import { useBoard } from "../board/BoardContext.jsx";
import { ThemeToggle } from "./ThemeToggle.jsx";

/* The masthead and the app's navigation. Where the single-file build had a
   row of buttons opening modals, each destination is now a route with its
   own URL — the nav is the router. */
export function TopBar() {
  const { user, isAdmin, signOut } = useAuth();
  const { saving, dirty, error, board } = useBoard();
  const navigate = useNavigate();

  /* "Live" is only true when there is nothing left to write. A queued edit
     anywhere on the board gets a neutral bead rather than the green one,
     so this never claims more than the drawer's Save button does. */
  const status = error
    ? { cls: "is-off", text: "Not saving" }
    : saving
      ? { cls: "is-on", text: "Saving…" }
      : dirty
        ? { cls: "", text: "Unsaved" }
        : { cls: "is-on", text: "Live" };

  async function out() {
    await signOut();
    navigate("/login", { replace: true });
  }

  return (
    <header className="topbar">
      <div className="mark">
        <h1>War Room</h1>
        {/* Counted, not written down: the board stopped being exactly ten
            the moment a playground could be added. */}
        <span className="sub">
          INSOMNIACS &middot; {board ? board.length : "—"} PLAYGROUND
          {board && board.length === 1 ? "" : "S"}
        </span>
      </div>

      <nav className="navlinks" aria-label="Sections">
        <NavLink to="/" end className="navlink">
          Board
        </NavLink>
        <NavLink to="/accountability" className="navlink">
          Accountability
        </NavLink>
        <NavLink to="/core-group" className="navlink">
          Core group
        </NavLink>
        <NavLink to="/note" className="navlink">
          Send a note
        </NavLink>
        <NavLink to="/manual" className="navlink">
          User Manual
        </NavLink>
        {isAdmin && (
          <NavLink to="/access" className="navlink">
            Access
          </NavLink>
        )}
        {isAdmin && (
          <NavLink to="/data" className="navlink">
            Data
          </NavLink>
        )}
      </nav>

      <div className="toolbar">
        <div className={"status " + status.cls} title={error || undefined}>
          <span className="bead" />
          <span>{status.text}</span>
        </div>
        <NavLink to="/account" className="whoami" title={user.email}>
          {user.avatarUrl ? (
            <img src={user.avatarUrl} alt="" width="22" height="22" />
          ) : (
            <span className="initial" aria-hidden="true">
              {(user.name || user.email).slice(0, 1).toUpperCase()}
            </span>
          )}
          <span className="who">{user.name || user.email}</span>
          {isAdmin && <span className="rolechip">admin</span>}
        </NavLink>
        <ThemeToggle />
        <button className="btn btn-sm" type="button" onClick={out}>
          Sign out
        </button>
      </div>
    </header>
  );
}
